import {useCallback} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {selectGiftingData} from '~/CreateFabricInvitation/reducers/giftingOptions/selectors';
import {UPDATE_GIFT_OPTIONS} from '~/common/fabric/reducers/giftingOptions/constants';
import {selectGiftingOptionsOptions} from '~/common/fabric/reducers/giftingOptions/selectors';
import {selectEvent} from '~/common/gift-keywords/utils';
import {eviteVendors, getWalmartURL} from '~/common/vendors/vendors';
import {VendorDisc} from '~/ViewInvitation/common/VendorDisc';
import {Button} from '~library/atoms/Button';
import {DiamondIcon} from '~library/svg/DiamondIcon';

import './GiftIdeas.sass';

type GiftIdeas = {
  shouldShowUpsellModal: () => boolean;
  setToToggleOff: (option: string) => void;
  toggleUpsellModal: () => void;
  eventIsPremium: boolean;
};

export const GiftIdeas = ({
  shouldShowUpsellModal,
  setToToggleOff,
  toggleUpsellModal,
  eventIsPremium,
}: GiftIdeas) => {
  const dispatch = useDispatch();
  const event = useSelector(selectEvent);
  const giftingOptions = useSelector(selectGiftingOptionsOptions);
  const giftingData = useSelector(selectGiftingData, shallowEqual);
  const displayText = 'Browse gift guides';
  const walmartURL = getWalmartURL(event);
  const walmartVendor = eviteVendors.find(({name}) => name === 'Walmart');

  const removeAction = useCallback(() => {
    dispatch({
      type: UPDATE_GIFT_OPTIONS,
      payload: {
        showGifting: false,
        options: {
          ...giftingOptions.options,
          // biome-ignore lint/style/useNamingConvention: API expects the property name in snake_case
          event_option_show_gifting: false,
        },
      },
    });
  }, [giftingOptions.options, dispatch]);

  const onRemove = useCallback(async () => {
    if (shouldShowUpsellModal()) {
      setToToggleOff('giftIdeas');
      toggleUpsellModal();
    } else {
      removeAction();
    }
  }, [removeAction, setToToggleOff, shouldShowUpsellModal, toggleUpsellModal]);

  return (
    <>
      <Button
        variant="unstyled-button"
        className="gift-ideas__remove"
        data-qa-id="remove-gifting"
        onClick={onRemove}
      >
        {!eventIsPremium && <DiamondIcon ratio={1.143} />}
        Remove
      </Button>
      <div className="gift-ideas__vendor-list" data-qa-id="gifting-vendor-list">
        <VendorDisc
          registry={giftingData}
          dataQaId={`af-invite-disc-${giftingData.vendorName.toLowerCase().replace(' ', '-')}`}
          displayText={displayText}
        />
        <VendorDisc
          registry={{
            ...walmartVendor,
            // biome-ignore lint/style/useNamingConvention: existing error
            vendor_name: walmartVendor?.name,
            url: walmartURL,
          }}
          dataQaId="af-invite-disc-walmart"
          displayText={displayText}
        />
      </div>
    </>
  );
};
